import React, {useContext, useEffect, useState} from 'react';
import JobListViewContext, { RightClickContext } from '../common/JobListViewContext';
import { UTTaskMemoListItem } from '../../fms.data/models/UTTaskMemoListItem';
import { getOpByjobName, getOpTypeConstant, JobNames } from '../../framework.core/JobNames';
import { ActionButtonItem, borderColors, splitMenuItemsIntoSections } from '../../ui/ActionButton';
import ToolboxMenuItem from '../../uiControls/ToolboxMenuItem';
import ListViewShortcutMenu from '../common/ListViewShortcutMenu';
import useFunctionKeys from '../../hooks/useFunctionKeys';
import InfoAreaDrawer from '../../uiControls/infoArea/InfoAreaDrawer';
import AbstractListView, { DataFetchResult, ExportRowRenderer, ListCustomFilterRenderer, ListOrderBy, ListRowRenderer } from '../common/AbstractListView';
import { Search } from '../../filtering';
import constants from '../../constants';
import { DateRenderer, DateTimeRenderer, FloatRenderer, NullableCheckboxIconRenderer, TextAlignLeftRenderer, TextRenderer } from '../../uiControls/SmartTableRenderers';
import { TableColumn, TableSettings, utTaskMemoListItem } from '../../tableSettings';
import JobListSuntekCommand from '../common/JobListSuntekCommand';
import * as XCol from '../../framework.core/XExportColumn';
import Menu, { IfmsMenuItem } from '../../ui/menu/Menu';
import { NavigationType, openNewPage } from '../../util/navigationHelpers';
import { useHistory } from 'react-router-dom';
import Select from '../../ui/Select';

/*
function useSelectedOperations() {
  // const jobListContext = useContext(JobListViewContext);
  // const appContext = useContext(ApplicationContext);
  // const history = useHistory();
  //const operation = 'accounting';

  // const selectedElement = jobListContext.selectedElement as UTTaskMemoListItem;

  // const [showGlobalOkDialog] = useGlobalOkDialog();
  // const [showGlobalYesNoDialog] = useGlobalYesNoDialog();

  // async function create() {
  //   if (jobListContext.hasOpenedScreenStartingWithUrl(`/${operation}/acPrepaidExpenseAdjustment/add`)) {
  //     await showGlobalOkDialog(<p>New operation is already in progress</p>);
  //     return;
  //   }

  //   openNewPage(history, `/${operation}/acPrepaidExpenseAdjustment/add`, NavigationType.newPage);
  // }

  // async function deleteEntity() {
  //   if (!selectedElement) {
  //     return;
  //   }
  
  //   const doDelete = await showGlobalYesNoDialog(
  //     <div>
  //       <h3>Confirm to Delete?</h3>
  //     </div>
  //   );

  //   if (doDelete) {
  //     const apiResult = await appContext.api.deleteJobDetail(JobNames.PrepaidExpenseAdjustment, {
  //       id: selectedElement.id,
  //       pimsLinkId: 0
  //     });
  //     if (apiResult && apiResult.success) {
  //       jobListContext.reloadData();
  //     } else {
  //       const message = apiResult?.message ?? 'Cannot delete!';
  //       await showGlobalOkDialog(message);
  //     }
  //   }
  // }

  // async function edit() {
  //   if (!selectedElement) {
  //     return;
  //   }

  //   if (jobListContext.hasOpenedScreenStartingWithUrl(`/${operation}/acPrepaidExpenseAdjustment/edit`)) {
  //     await showGlobalOkDialog(<p>Edit operation is already in progress</p>);
  //     return;
  //   }

  //   const id = selectedElement.id;
  //   openNewPage(history, `/${operation}/acPrepaidExpenseAdjustment/edit/${id}`, NavigationType.newPage);
  // }

  // async function view() {
  //   if (!selectedElement) {
  //     return;
  //   }

  //   const id = selectedElement.id;

  //   const viewUrl = `/${operation}/acPrepaidExpenseAdjustment/view/${id}`;

  //   if (jobListContext.hasOpenedScreenStartingWithUrl(viewUrl)) {
  //     await showGlobalOkDialog(<p>View operation is already in progress</p>);
  //     return;
  //   }

  //   openNewPage(history, viewUrl, NavigationType.newPage);
  // }

  // async function copy() {
  //   if (!selectedElement) {
  //     return;
  //   }

  //   if (jobListContext.hasOpenedScreenStartingWithUrl(`/${operation}/acPrepaidExpenseAdjustment/add`)) {
  //     await showGlobalOkDialog(<p>New operation is already in progress</p>);
  //     return;
  //   }

  //   const id = selectedElement.id;
  //   openNewPage(history, `/${operation}/acPrepaidExpenseAdjustment/add?copyId=${id}`, NavigationType.newPage);
  // }

  return {};
}
*/

function MemoOPTypeFilterRenderer({ value, onChange, onEnter }: any) {
  return (
    <>
    <Select
      name='ifms-filter-rqcol-select'
      value={value}
      onChange={e => onChange(e.target.value)}
      items={[
        { label: 'Manifest', value: 'ODM' },
        { label: 'Load', value: 'ODL' },
        { label: 'Local D/O', value: 'ODD' },
        { label: 'Receiving', value: 'WHR' },
        { label: 'Shipping', value: 'WHS' },
        { label: 'Invoice', value: 'INV' },
        { label: 'Bill', value: 'APH' },
        { label: 'CrDb', value: 'CRD' },
        { label: 'Bill Pay', value: 'BPAY' },
        { label: 'Customer Pay', value :'CPAY'},
        { label: 'Customer Pay Memo', value: 'ARC' },
        { label: 'Bank Recon', value: 'BANKRECON' },    
        { label: 'Bank Transfer', value: 'BANKTRAN' },    
        { label: 'Customer', value: 'COM' },
        { label:  'Payroll', value: 'PAYROLL'},    
      ]}
      applySearchWithEnter={onEnter}
    />
    </>
  );
}

function getLabelByJobName(jobName: JobNames){
  switch(jobName){
    case JobNames.BTOrder: 
     return 'Manifest';
    case JobNames.BTLoadPlan: 
    return 'Load';
    case JobNames.BTDo:
     return'Local D/O';
    case JobNames.WHRcv:
      return 'Receiving';
    case JobNames.WHShip:
      return'Shipping'; 
    case JobNames.GBill: 
    case JobNames.Bill:
      return 'Bill';
    case JobNames.GInvo:
    case JobNames.Warehouse:
    case JobNames.WHStorageInv:
    case JobNames.Invoice:
      return 'Invoice'; 
    case JobNames.WHCrDb:
      return 'CrDb';
    case JobNames.CustPayment:
      return 'Customer Pay';
    case JobNames.BillPayment:
      return 'Bill Pay';
    case JobNames.CustPaymentMemo:
      return 'Customer Pay Memo';
    case JobNames.Company:
      return 'Customer';
    case JobNames.BankTransfer:
      return 'Bank Transfer';
    case JobNames.BankRecon:
      return 'Bank Recon';
    case JobNames.Payroll2:
      return 'Payroll';
    default : 
      return '';
  }
}

function MemoOPTypeRenderer({ cell, row, data }: any) {
  const l = data[row.index];
  const jobName = getJobNameByOpTypeAndAcctType(l.opType, l.acctType);
  let label = getLabelByJobName(jobName);

  return <div id={`${cell.column.id}-${row.index}`} className={'ifms-table-memo-optype'}>{label}</div>;
}

function useListOperations(){
  const history = useHistory();
  const jobListContext = useContext(JobListViewContext);

  function switchToListFor(opType: string, acctType: string, tbId: string) {
    let blType = '';
    let jobName = getJobNameByOpTypeAndAcctType(opType, acctType);
    let parentOpType = false;
    let parentOpName = '';
    let opName = getOpByjobName(jobName);
    let orderby = 'update';
    switch(jobName) {
      case JobNames.WHRcv:
        blType = 'whReceiving';
        opName = constants.opTypes.warehousing;
        break;
      case JobNames.WHShip:
        blType = 'whShipping';
        opName = constants.opTypes.warehousing;
        break;
      case JobNames.Company:
        blType = 'company';
        opName = constants.opTypes.customer;
        break;
      case JobNames.Invoice:
        blType = 'invoice';
        parentOpName = 'billings';
        opName = constants.opTypes.accounting;
        parentOpType = true;
        break;
      case JobNames.GInvo:
        blType = 'acGeneralInvoice';
        parentOpType = true;
        opName = constants.opTypes.accounting;
        parentOpName = 'billings';
        break;
      case JobNames.WHStorageInv:
        blType = 'whStorageInvoice';
        opName = constants.opTypes.warehousing;
        break;
      case JobNames.Bill:
        blType = 'bill';
        parentOpName = 'billings';
        opName = constants.opTypes.accounting;
        parentOpType = true;
        break;
      case JobNames.GBill:
        blType = 'acGeneralBill';
        parentOpType = true;
        opName = constants.opTypes.accounting;
        parentOpName = 'billings';
        break;
      case JobNames.WHCrDb:
        blType = 'crdb';
        opName = constants.opTypes.warehousing;
        break;
      case JobNames.CustPaymentMemo:
        blType = 'acCustomerPaymentMemo';
        opName = constants.opTypes.accounting;
        break;
      case JobNames.CustPayment:
        blType = 'acCustomerPayment';
        opName = constants.opTypes.accounting;
        break;
      case JobNames.BillPayment:
        blType = 'acBillPayment';
        opName = constants.opTypes.accounting;
        break;
      case JobNames.BTOrder:
        blType = 'btOrder';
        opName =constants.opTypes.order;
        orderby = 'u2Date';
        break;
      case JobNames.BTDo:
        blType = 'btLocalDO';
        opName = constants.opTypes.localDO;
        orderby = 'u2Date';
        break;
      case JobNames.BTLoadPlan:
        blType = 'btLoadPlan';
        opName = constants.opTypes.load;
        orderby = 'u2Date';
        break;
      case JobNames.BankTransfer:
        blType = 'acBankTransfer';
        opName = constants.opTypes.accounting;
        break;
      case JobNames.BankRecon:
        blType = 'acBankRecon';
        opName = constants.opTypes.accounting;
        break;
      case JobNames.Payroll2:
        blType = 'acPayroll2';
        opName = constants.opTypes.accounting;
    }
    jobListContext.setFilterForScreenExternally(`/common/joblistview/${blType}/${opName}${parentOpType? `?parentOp=${parentOpName}`:''}`,
      'id', '', tbId.toString(), orderby, false, true, null);
    openNewPage(history, `/common/joblistview/${blType}/${opName}${parentOpType? `?parentOp=${parentOpName}`:''}`, NavigationType.newPage);
  }
  return {switchToListFor};
}

function getJobNameByOpTypeAndAcctType(opType: string, acctType: string){
  switch(opType){
    case 'ODM': return JobNames.BTOrder;
    case 'ODL': return JobNames.BTLoadPlan;
    case 'ODD' : return JobNames.BTDo;
    case 'WHR' : return JobNames.WHRcv;
    case 'WHS' : return JobNames.WHShip;
    case 'APH' :
      if(acctType == 'G') return JobNames.GBill;
      else return JobNames.Bill;
    case 'INV' :
      if(acctType == 'G') return JobNames.GInvo;
      else if (acctType == 'P') return JobNames.Warehouse;
      else if (acctType == 'S') return JobNames.WHStorageInv;
      else return JobNames.Invoice;
    case 'CRD': return JobNames.WHCrDb;
    case 'CPAY': return JobNames.CustPayment;
    case 'BPAY': return JobNames.BillPayment;
    case 'ARC': return JobNames.CustPaymentMemo;
    case 'COM' : return JobNames.Company;
    case 'BANKTRAN': return JobNames.BankTransfer;
    case 'BANKRECON': return JobNames.BankRecon;
    case 'PAYROLL' : return JobNames.Payroll2;
    default : return JobNames.None;
  }
}

function useSelectedOperations(){
  const jobListContext = useContext(JobListViewContext);
  const selectedElement = jobListContext.selectedElement as UTTaskMemoListItem;
  const {switchToListFor} = useListOperations();

  function switchToList(){
    if(selectedElement.refNo){
      switchToListFor(selectedElement.opType, selectedElement.acctType, selectedElement.tbId);
    }

  }
 
  return {switchToList};
  
}

function RightClickMenu({dismiss}:{dismiss: VoidFunction}) {
  //const { create, deleteEntity, edit, view } = useSelectedOperations();
  const jobListContext = useContext(JobListViewContext);
  const {switchToList} = useSelectedOperations();
  //const appContext = useContext(ApplicationContext);
  // const listSec = findSecurityTask(appContext, FmsSecTask.AcctPrepaidAdjustment);
  const selectedElement = jobListContext.selectedElement as UTTaskMemoListItem;
  const jobName = getJobNameByOpTypeAndAcctType(selectedElement.opType, selectedElement.acctType);
  const label = getLabelByJobName(jobName);
  const items = [
    { label: 'Search', shortcut: 'F5', separator: false },
    { label: 'Refresh', shortcut: 'F11', separator: !!selectedElement.refNo },
    { label: `Go to ${label} List`, shortcut: 'F6', hidden: !selectedElement.refNo},
  ];

  const menuItems: ActionButtonItem[] = items.map((i, index) =>({
    label: <ToolboxMenuItem width="190px" label={i.label} shortcut={i.shortcut} />,
    separator: i.separator,
    selected: false,
    index,
    hidden: i.hidden
  }));

  function onMenuItemSelected(item:IfmsMenuItem) {
    switch (item.index) {
      case 0:
        jobListContext.triggerTableSearch('F5');
        break;
      case 1:
        jobListContext.reloadData();
        break;
      case 2:
        switchToList();
        break;
      default:
        break;
    }
    dismiss();
  }

  return (
    <Menu
      variant="plain"
      specialMenu='rightClickContext'
      items={splitMenuItemsIntoSections(menuItems)}
      mode="vertical"
      onMenuItemSelected={onMenuItemSelected}
      subMenuStyle={{
        minWidth: 150,
        whiteSpace: 'nowrap',
      }}
      menuStyle={(i: number) => ({
        maxHeight: '300px',
        overflowY: 'hidden',
        padding: 0,
        borderTop: `3px solid ${borderColors[i % borderColors.length]}`,
        paddingTop: 10,
      })}
      dismiss={dismiss}
    />
  );
}

function ListCommands() {
  return (
    // <div className="ifms-common-no-vertical-separator">
    //   <UniqueLinkButton display="primary" size="regular" link={''} disabled
    //                     label={<span><FontAwesomeIcon icon={faPlus}/>&nbsp; New</span>}/>&nbsp;
    //   <PrimaryButton size="regular" disabled ><FontAwesomeIcon
    //     icon={faFileAlt}/>&nbsp; View</PrimaryButton>&nbsp;
    //   <PrimaryButton size="regular" disabled ><FontAwesomeIcon
    //     icon={faPencilAlt}/>&nbsp; Edit</PrimaryButton>&nbsp;
    //   <PrimaryButton size="regular" disabled ><FontAwesomeIcon
    //     icon={faTrashAlt}/>&nbsp; Delete</PrimaryButton>&nbsp;
    // </div>
    <></>
  );
}

function ListToolbar() {
  return (
    <>
      <ListViewShortcutMenu />
    </>
  );
}

function ListViewExtras() {
  useFunctionKeys({onFunction: onFunctionKey});

  const jobListContext = useContext(JobListViewContext);

  //const {create, edit, view} = useSelectedOperations();
  const { switchToList } = useSelectedOperations();
  const [unprocessedFkey, setUnprocessedFkey] = useState<string | null>(null);

  useEffect(() => {
      if (!unprocessedFkey) {
        return;
      }

      doProcessFkey();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [unprocessedFkey]
  );

  function doProcessFkey() {
    if (unprocessedFkey === "F11") {
      jobListContext.reloadData();
    } else if (unprocessedFkey === "F5") {
      jobListContext.triggerTableSearch('F5');
    } else if (unprocessedFkey === "F6"){
        switchToList();
    }

    setUnprocessedFkey(null);
  }

  function onFunctionKey(fkey: string) {
    if (['F5', 'F11', 'F6'].indexOf(fkey) >= 0) {
      setUnprocessedFkey(fkey);
      return true;
    }

    return false;
  }

  return (
    <InfoAreaDrawer
      showContent={jobListContext.infoAreaContent}
      jobName={JobNames.MemoList}
      jobId={(jobListContext.selectedElement as UTTaskMemoListItem | null)?.id ?? 0}
      customTabs={[
      ]}
      onClose={() => jobListContext.setInfoAreaContent('none')}
    />
  );
}

/**
 *
 * @class MemoAllListView
 * @extends {AbstractListView}
 */
class MemoAllListView extends AbstractListView {
  async fetchAndFormatData(api: any, search: Search): Promise<DataFetchResult> {
    const apiResult = await api.getListItems(
      JobNames.MemoList,
      'UTTaskMemoListItem',
      UTTaskMemoListItem.calculateSearchParameters(search,UTTaskMemoListItem.MapSearchFields),
      1,
      search.pageSize,
    );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return {data: [], totalCount: 0};
    }

    return {data: UTTaskMemoListItem.formatData(apiResult.entities), totalCount: apiResult.totalCount};
  }

  getCustomFilterRenderers(): ListCustomFilterRenderer[] {
    return [
            {
              accessor: 'opType',
              renderer: MemoOPTypeFilterRenderer,
              searchValueExtractor: (v: any | null | undefined) => v,
            },
    ];
  }

  getInfoAreaEntityId() {
    return constants.infoAreaEntity.oceanImportMbl;
  }

  getRowRenderers(): ListRowRenderer[] {
    return UTTaskMemoListItem.getExportCollection().map(x => {
      const colRenderer:ListRowRenderer = { accessor: x.dataIndex, Cell: TextAlignLeftRenderer };
      if(x.type === XCol.XCellType.Double) colRenderer.Cell = (props:any) => <FloatRenderer {...props} decimals={2} />;
      else if (x.dataIndex === 'opType'){
        colRenderer.Cell = MemoOPTypeRenderer;
        
      } 
      else if(x.type === XCol.XCellType.Bool || x.type === XCol.XCellType.StrBool) colRenderer.Cell = NullableCheckboxIconRenderer;
      else if(x.type === XCol.XCellType.Date) colRenderer.Cell = DateRenderer;
      else if(x.type === XCol.XCellType.DateTime) colRenderer.Cell = DateTimeRenderer;
      else if(x.align === XCol.XAlignType.Center) colRenderer.Cell = TextRenderer;

      return colRenderer;
    });
  }
  
  getExportRenderers(): ExportRowRenderer[] {
    const colRenderer = [];
    colRenderer.push({accessor: 'status', changedValue: (value: any)=> { return value['status'] === 'PC' ? 'Period Close' : ''}});
    return colRenderer;
  }

  getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'createdAt',
      orderByAscending: false,
    };
  }

  getTableSettings(): TableSettings {
    const tsettings =  utTaskMemoListItem;
    const cols = UTTaskMemoListItem.getExportCollection();
    tsettings.columns = cols.map<TableColumn>(x => {
      return { ...x, accessor: x.dataIndex, Header: x.text, filterType: undefined, filterTypeV2: x.type};
    });
    return tsettings;
  }

  renderCommands() {
    return (
      <ListCommands/>
    );
  }

  renderBeforeConfigureButton() {
    return (
      <ListToolbar/>
    );
  }

  
  hasMemo(): boolean {
    return false;
  }
  renderExtras() {
    return <ListViewExtras/>
  }

  getViewUrlFor(row: UTTaskMemoListItem) {
    return '';
  }

  getListViewTitle() {
    return 'Memo/Task List';
  };

  renderAdditionalCommands() {
    return <JobListSuntekCommand jobName={JobNames.MemoList} keyProp='id' showAdjustBalance={false} />;
  }

  hasRightClickContext(): boolean {
    return true;
  }

  renderRightClickContext(context: RightClickContext, dismiss: VoidFunction): React.ReactNode {
    return <RightClickMenu dismiss={dismiss} />;
  }
}

export default MemoAllListView;